import { apiHelper } from '../../utils/apiHelper';

// const API_URL = `${process.env.REACT_APP_API_URL}/api/admin/page`;
const API_URL2 = `${process.env.REACT_APP_API_URL}/api/admin/section`;
const API_URL3 = `${process.env.REACT_APP_API_URL}/api/admin`;

// const headers = {
//   "Content-Type": "multipart/form-data",
//   "Accept": "application/json"
// };

const headers2 = {
  "Content-Type": "multipart/form-data",
};

export const fetchSections = (payload) => apiHelper(API_URL2, 'GET', payload);
export const modifySection = (sectionId, payload) => apiHelper(`${API_URL2}/${sectionId}`, 'POST', payload, headers2);
export const addSubSections = (payload) => apiHelper(`${API_URL3}/add-section-content`, 'POST', payload, headers2); 
export const deleteSubSections = (subSectionId) => apiHelper(`${API_URL3}/delete-section-content/${subSectionId}`, 'DELETE');
